<template>
  <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" append-to-body :destroy-on-close="true" custom-class="member-detail-dialog" top="60px" width="90vw" :before-close="handleClose" @close="closeDialog">
    <div slot="title" class="flex align-items-center">
      <div class="hd flex align-items-center">
        <img v-if="list.avatar" :src="list.avatar" alt class="image rounded mr-sm" />
        <img v-else src="@/assets/default-avatar.png" alt class="image rounded mr-sm" />
        <div style="max-width: 420px;" class="ellipsis">
          <span class="font-md ellipsis" style="line-height: 28px;">{{ list.nickname }}</span>
          <div v-if="list.customer_level" class="text-blue font-sm">
            {{ list.company_name }}
          </div>
        </div>
        <div v-if="memberid" class="font-2x box-border pl pr ml mr star flex align-items-center" style="height: 30px;line-height: 30px;">
          <el-rate v-model="list.customer_level" @change="rateChange"></el-rate>
        </div>
      </div>
      <div class="bd menu-left flex pl">
        <div class="bd">
          <el-menu :default-active="currentActive" background-color text-color="#333" active-text-color="#07c160" mode="horizontal" @select="handleLeftMenuSelect">
            <el-menu-item index="Basic">基本信息</el-menu-item>
            <el-menu-item index="BindDevice">绑定设备</el-menu-item>
            <el-menu-item index="ConsumeRecord">增值订单</el-menu-item>
            <el-menu-item index="ProductOrder">商品订单</el-menu-item>
          </el-menu>
        </div>
      </div>

      <div v-if="memberid" class="ft mr-lg" role="button">
        <el-tooltip v-if="!list.is_collected" content="最小化收藏" popper-class="minimize-collect" placement="top" :open-delay="500" :disabled="list.is_collected == 1">
          <i @click="addCollected" class="iconfont icon-pin text-muted"></i>
        </el-tooltip>
        <el-tooltip v-else content="取消最小化收藏" popper-class="minimize-collect" placement="top" :open-delay="500" :disabled="list.is_collected == 0">
          <i @click="cancelCollected" class="iconfont icon-pin-b text-yellow"></i>
        </el-tooltip>
      </div>
    </div>
    <el-row :gutter="20" v-if="currentActive == 'Basic'" class="pl pr" style="height: 100%;">
      <el-col v-loading="loading" :span="12" style="height: 100%;">
        <el-card shadow="never" class="card-item basic-card">
          <div class="mb-lg">
            <span class="front-line">用户信息</span>
          </div>
          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">名称</div>
            <div class="flex1 content ellipsis">
              {{ list.nickname }}
              <span v-if="list.is_relater && list.relater_status == 1" class="text-primary ml-xs">@成员</span>
            </div>
          </div>

          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">会员类型</div>
            <div class="flex1 content flex align-items-center justify-content-space-between">

              <ProTag v-if="list.expire_day" :expire_day="list.expire_day" :internal="true" :full="true"></ProTag>
              <div v-else>普通会员</div>
              <el-button type="text" class="mr" @click="gift()">赠送</el-button>
            </div>
          </div>
          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">标签</div>
            <div class="flex1 content flex justify-content-space-between align-items-center">
              <div>
                <el-tag v-for="tag in tags" :key="tag.tagid" class="mb mr tag" style="margin-top: 15px" type="blue">
                  {{
                  tag.title }}
                </el-tag>
              </div>
              <el-button type="text" class="mr" @click="showDialog">打标签</el-button>
            </div>
          </div>
          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">备注</div>
            <div class="flex1 content flex justify-content-space-between">
              <span>{{ list.remark }}</span>
              <el-button type="text" class="mr" @click="edit()">修改</el-button>
            </div>
          </div>

          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">注册时间</div>
            <div class="flex1 content">{{ list.createtime | parseTime('{y}/{m}/{d}') }}</div>
          </div>
          <div class="flex align-items-center">
            <div class="text-muted" style="width: 100px">最近活跃时间</div>
            <div class="flex1 content">{{ list.lastvisit | parseTime('{y}/{m}/{d}') }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" class body-style="height: 75vh;">
          <div class="mb">
            <span class="front-line">最近活跃度</span>
          </div>
          <div class="flex column align-items-center">
            <member-active-heatmap v-if="memberid" :memberid="memberid" style="height: 30vh;width: 480px;" />
            <div class style="width:100%;height:5vh"></div>
            <member-active-curve v-if="memberid" :memberid="memberid" class style="height: 30vh;width: 480px;" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-card v-else-if="currentActive == 'BindDevice'" shadow="never" class="mr ml card-item">
      <div class="card-top flex mb-xs">
        <f-radio-btn-group v-model="query.equip_status" class="reverse mr-sm" :groups="equipEventTypeArr" @change="getMemberBindList(1)" />
        <el-checkbox v-model="query.owner_auth" label="归属权" border :true-label="1" :false-label="0" @change="getMemberBindList(1)"></el-checkbox>
        <div class="ml-sm mr-sm" style="width: 160px;">
          <el-select v-model="query.member_auth" placeholder="权限" @change="getMemberBindList(1)" filterable clearable>
            <el-option v-for="(item, index) in authArr" :key="index" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </div>
        <f-date-picker v-model="query.expire_day" :shortcuts="[0, 'end', 'lastMonthEnd']" clearable placeholder="有效期至" style="width: 160px" @change="getMemberBindList(1)" />
        <div class="ml-sm" style="width: 200px;">
          <el-input v-if="memberid" v-model="query.keyword" placeholder="名称 / GO码" prefix-icon="el-icon-search" clearable @change="getMemberBindList(1)" />
        </div>
      </div>
      <el-table ref="equipBindList" v-loading="tableLoading" key="bindDeviceTable" :data="equips" tooltip-effect="dark" class="padding-mini card-table" @selection-change="handleSelectionChange" :default-sort="{ prop: 'bindtime', order: 'descending' }" @sort-change="sortChange">
        <el-table-column width="60" type="selection" />
        <el-table-column width="60">
          <template slot-scope="scope">
            <f-equip-avatar :equip="scope.row" />
          </template>
        </el-table-column>
        <el-table-column prop="go" :show-overflow-tooltip="true" label="GO码" width="180">
          <template slot-scope="scope">
            <f-equip-name :equip="{ equipid: scope.row.equipid, go: scope.row.go }" />
          </template>
        </el-table-column>
        <el-table-column prop="name" :show-overflow-tooltip="true" label="用户自定义名称" min-width="180">
          <template slot-scope="scope">
            <f-equip-name :equip="{ equipid: scope.row.equipid, name: scope.row.name }" />
          </template>
        </el-table-column>
        <el-table-column prop="status" :show-overflow-tooltip="true" label="状态" min-width="80" />

        <el-table-column label="权限" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.member_auth > scope.row.user_auth">{{ authObj[scope.row.member_auth].title }}</span>
            <el-dropdown v-else trigger="click" @command="updateMemberAuth">
              <span class="el-dropdown-link">
                {{ authObj[scope.row.member_auth].title }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <template v-for="auth in authArr">
                  <el-dropdown-item v-if="auth.value <= scope.row.user_auth && auth.value > 0" :key="auth.value" :command="{ equip: scope.row, rank: auth.value }">{{ auth.title }}</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column label="绑定时间" prop="bindtime" :show-overflow-tooltip="true" sortable="custom" :sort-orders="sortOrders" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.bindtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expire_day" label="有效期" :show-overflow-tooltip="true" sortable="custom" :sort-orders="sortOrders" min-width="120">
          <template slot-scope="scope">
            <span :class="{'text-danger': now > scope.row.expire_day}">{{ scope.row.expire_day | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="toRmsDetail(scope.row.equipid)">查看</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="image huger" />
          </div>
        </template>
      </el-table>
      <f-table-footer v-if="memberid" :list="equips" :selection="multipleSelection" checkbox @toggle="toggleAll">
        <span class="mr-sm" v-show="multipleSelection.length">已选 <span class="text-success">{{multipleSelection.length}}</span> 台设备</span>
        <el-button type="success" size="mini" :plain="multipleSelection.length === 0" :disabled="multipleSelection.length === 0" @click="equipShareShow = true">分享移交</el-button>
        <el-button
          type="success"
          size="mini"
          :plain="multipleSelection.length === 0"
          :disabled="multipleSelection.length === 0"
          @click="openAuthDialog"
        >
          授权
        </el-button>
        <template slot="right">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="getMemberBindList" />
        </template>
      </f-table-footer>
    </el-card>
    <el-card v-else-if="currentActive == 'ConsumeRecord'" shadow="never" class="mr ml card-item">
      <el-table ref="consumeRecord" v-loading="consumeLoading" :data="order" tooltip-effect="dark" class="card-table">
        <el-table-column width="60" type="index" label="#" />
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="订单编号">
          <template slot-scope="scope">{{ scope.row.order_sn }}</template>
        </el-table-column>
        <el-table-column min-width="240" :show-overflow-tooltip="true" label="订单主题">
          <template slot-scope="scope">{{ scope.row.subject }}</template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true" label="实付金额">
          <template slot-scope="scope">
            <span v-if="scope.row.total_payed" class="text-success font-md">￥{{ scope.row.total_payed.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true" label="商家优惠">
          <template slot-scope="scope">
            <span v-if="(scope.row.total_discount_fee_mch) > 0" class="font-md">
              ￥{{
              (scope.row.total_discount_fee_mch).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true" label="平台优惠">
          <template slot-scope="scope">
            <span v-if="scope.row.total_discount_fee_plat > 0" class="font-md">
              ￥{{ scope.row.total_discount_fee_plat.toFixed(2)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="num" :show-overflow-tooltip="true" label="数量" width="80" />
        <el-table-column prop="paytime" label="支付时间" :show-overflow-tooltip="true" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.paytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="120">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.order_status == 10">{{ '待发货' }}</el-tag>
            <el-tag type="warning" v-else-if="scope.row.order_status == 20">{{ '待收货' }}</el-tag>
            <el-tag type="success" v-else>{{ '已完成' }}</el-tag>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="image huger" />
          </div>
        </template>
      </el-table>
      <f-table-footer v-if="memberid" :list="order">
        <template slot="right">
          <f-pagination :total="total2" :pindex.sync="query2.pindex" :psize.sync="query2.psize" @change="fetchOrder" />
        </template>
      </f-table-footer>
    </el-card>
    <el-card v-else-if="currentActive == 'ProductOrder'" shadow="never" class="mr ml card-item">
      <div class="card-top flex mb-xs">
        <div>
          <f-date-range-picker v-model="productOrderQuery.createtime" :shortcuts="[0, -7, -30, -90, -180, -360]" @change="fetchProductOrder(1)" />
        </div>
        <div class="ml-sm mr-sm" style="width: 160px;">
          <el-select v-model="productOrderQuery.pay_status" placeholder="支付状态" clearable filterable style="width: 160px;"
            @change="fetchProductOrder(1)">
            <el-option v-for="item in payStatus" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="ml-sm mr-sm" style="width: 160px;">
          <el-select v-model="productOrderQuery.shipping_status" placeholder="发货状态" clearable filterable style="width: 160px;"
            @change="fetchProductOrder(1)">
            <el-option v-for="item in shippingStatus" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="ml-sm" style="width: 200px;">
          <el-input v-model="productOrderQuery.keyword" placeholder="订单编号/标题/备注" prefix-icon="el-icon-search" clearable @change="fetchProductOrder(1)" />
        </div>
      </div>
      <el-table ref="productOrderTable" :data="productOrderList" class="card-table">
        <el-table-column type="index" label="#" />

        <el-table-column prop="order_sn" label="订单编号" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #303133;font-size: 14px;">{{ scope.row.order_sn }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="subject" label="订单主题" min-width="180" show-overflow-tooltip />
        <el-table-column label="订单金额" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.total_price | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态/完成时间" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_status === 1">{{ scope.row.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            <el-tag v-else-if="scope.row.pay_status === 0" type="danger">待支付</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发货状态/签收时间" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.shipping_status === 3">{{ scope.row.shipping_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            <el-tag v-else-if="scope.row.shipping_status === 1" type="warning">已发货</el-tag>
            <el-tag v-else-if="scope.row.shipping_status === 0" type="danger">待发货</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="60">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.remark" popper-class="prm-clue-tooltip-description" placement="top">
              <template slot="content">
                <el-scrollbar style="max-height: 400px;">
                  <div class="prm-clue-tooltip-description-content">
                    {{ scope.row.remark }}
                  </div>
                </el-scrollbar>
              </template>
              <i class="el-icon-chat-dot-round font-2x text-muted"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <f-table-footer v-if="memberid" :list="productOrderList">
        <template slot="right">
          <f-pagination
            v-if="memberid"
            :total="productOrderListTotal"
            :pindex.sync="productOrderQuery.pindex"
            :psize.sync="productOrderQuery.psize"
            @change="fetchProductOrder"
          />
        </template>
      </f-table-footer>
    </el-card>
    <el-dialog width="600px" class="tag-panel-dialog" :title="`「${list.nickname}」打标签`" :visible.sync="dialogShow" :modal-append-to-body="false" :append-to-body="true" @open="onOpen" @close="onClosed">
      <div v-loading="loading" class="pl" style="min-height: 200px;">
        <el-checkbox-group v-model="checkedTagids">
          <el-checkbox v-for="item in list2" :key="item.tagid" :label="item.tagid" class="tag-checkbox">
            {{ item.title }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="flex-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog width="1200px" custom-class="pro-dialog" :visible.sync="proShow" :modal-append-to-body="false" :append-to-body="true" @close="closePro">
      <div slot="title" class="font-md">赠送PRO会员</div>
      <div class="flex" style="height: 500px">
        <div class="bd pr-lg border-right">
          <div class="mb-lg">
            <span class="front-line">选择时长</span>
          </div>
          <div class="flex justify-content-center">
            <div v-for="(item, index) in proList" :key="index" class="pro-item" :class="[item.id == currentValue && 'active']" @click="select(item.id)">
              <div class="flex column justify-content-center" style="margin-top: 50px">
                <span style="font-size: 18px;">{{ item.title }}</span>
                <span class="mt-xs" style="font-size: 28px;margin-bottom: 3px;">￥{{ item.selling_subtotal }}</span>
                <span v-if="item.market_subtotal - item.selling_subtotal" class="text-muted" style="text-decoration: line-through;">￥{{ item.market_subtotal }}</span>
              </div>
              <div class="discount" :class="[item.id == currentValue && 'active']">
                <div v-if="item.market_subtotal - item.selling_subtotal" class="save">
                  立省 {{ item.market_subtotal -
                  item.selling_subtotal }}
                </div>
                <el-button v-if="item.id == currentValue" class="check" type="warning" icon="el-icon-check" circle></el-button>
              </div>
              <div v-if="item.id == currentValue" class="check-bg"></div>
            </div>
          </div>
        </div>
        <div class="ft pl-lg pr pt-sm pro-pay" style="width:380px;line-height: 1;">
          <div class="flex align-items-center mb">
            <img v-if="list.avatar" :src="list.avatar" alt class="image rounded mr-sm" />
            <img v-else src="@/assets/default-avatar.png" alt class="image rounded mr-sm" />
            <span class="font-lg mr-sm ellipsis">{{ list.nickname }}</span>
            <ProTag v-if="list.expire_day" :expire_day="list.expire_day" :internal="true"></ProTag>
          </div>
          <div class="flex align-items-center">
            <div class="hd mr">
              <div class="mb-sm desc-title">赠送到期时间</div>
              <div class="mb-sm desc-title">优惠金额</div>
              <div class="mb-sm desc-title">应付金额</div>
            </div>
            <div class="bd">
              <div class="mb-sm desc-content">{{ expire_time | parseTime('{y}年{m}月{d}日') }}</div>
              <div class="text-danger mb-sm desc-content">-{{ discount_fee | currency }}</div>
              <div class="text-success mb-sm desc-content">{{ total_payed | currency }}</div>
            </div>
          </div>
          <div class="foot-gift flex column justify-content-center">
            <el-button @click="immediatelyGift" class="button-gift" type="success">立即赠送</el-button>
            <div class="text-center mt-sm">
              付费即表示同意
              <a class="text-success" href="https://www.frippler.com/agreement/index.html" target="_blank">《云服务协议》</a>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <authorization-dialog v-if="authorizedShow" :show.sync="authorizedShow" :memberid="this.memberid" :auth-list="multipleSelection" @multipleAuthSuccess="getMemberBindList" />
    <rms-equip-share :show.sync="equipShareShow" :equips="multipleSelection" @change="getMemberBindList" />
  </el-dialog>
</template>

<script>
import {
  postMemberProfileApi,
  getMemberProfileApi,
  getMemberBindListApi,
  memberOrderApi,
  levelSetApi,
} from "@/api/up/upMemberApi";
import { updateEquipMemberAuthApi2 } from "@/api/rms/rmsEquipAuthApi";
import { getallApi, fetchApi, setApi } from "@/api/fam/famTagApi";
import {
  addCollectionApi,
  cancelCollectionApi,
  proOptionsApi
} from "@/api/rms/rmsMemberApi";
import { proPresentApi } from "@/api/ei/eiApi";
import { getGodProductOrderListApi } from "@/api/ei/eiMallApi";
import store from "@/store/store";
import router from '@/router/router'
export default {
  name: "FMemberDetail",

  components: {
    MemberActiveHeatmap: () => import("@/views/up/components/MemberActiveHeatmap.vue"),
    MemberActiveCurve: () => import("@/views/up/components/MemberActiveCurve.vue"),
    ProTag: () => import("@/views/up/components/ProTag.vue"),
    AuthorizationDialog: () => import("@/views/up/components/AuthorizationDialog.vue"),
    RmsEquipShare: () => import("@/views/rms/components/RmsEquipShare.vue"),
  },

  data() {
    return {
      loading: false,
      tableLoading: false,
      dialogVisible: false,
      consumeLoading: false,
      list: {},
      checkedTagids: [],
      list2: [],
      tags: [],
      order: [],
      memberid: 0,
      query: {
        memberid: 0,
        keyword: "",
        pindex: 1,
        psize: store.state.commonStore.psize,
        equip_status: 0,
        member_auth: null,
        expire_day: null,
        owner_auth: false,
        sortby: {
          key: 'bindtime',
          value: 'desc'
        }
      },
      sortOrders: ['descending', 'ascending'],
      query2: {
        memberid: 0,
        pindex: 1,
        psize: store.state.commonStore.psize,
      },
      total: 0,
      total2: 0,
      equips: [],
      remark: "",
      params: {
        equipid: 0,
        bind_type: "member",
        binderid: 0,
        auth_level: 0,
      },

      equipEventTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 2, title: "离线" },
        { value: 3, title: "在线" },
        { value: 5, title: "运行" },
        { value: 4, title: "告警" },
      ],
      value: "",
      currentActive: "Basic",
      dialogShow: false,
      now: parseInt(new Date().getTime() / 1000),
      // expire_day: 1670766498,
      proShow: false,
      proList: [],
      currentValue: "one_year",
      total_payed: 0,
      discount_fee: 0,
      expire_time: 0,

      multipleSelection: [],
      authorizedShow: false,
      equipShareShow: false,
      productOrderQuery: {
        pindex: 1,
        psize: store.state.commonStore.psize,
        memberid: null,
        keyword: '',
        createtime: null,
        pay_status: null,
        order_status: null
      },
      ProductOrderLoading: false,
      productOrderList: [],
      productOrderListTotal: 0,
      payStatus: [
        { value: 0, title: "待支付" },
        { value: 1, title: "已支付" },
      ],
      shippingStatus: [
        { value: 0, title: "待发货" },
        { value: 1, title: "已发货" },
        { value: 3, title: '已签收' }
      ],
    };
  },

  created() {},

  computed: {
    authObj() {
      return store.getters.authObj;
    },
    authArr() {
      return store.state.userStore.is_frippler ? store.state.rmsStore.authArr : store.state.rmsStore.authArr.slice(0, 6);
    },
  },

  methods: {
    rateChange(val) {
      levelSetApi({
        memberid: this.memberid,
        customer_level: val,
      }).then((res) => {
        if (res.errno === 0) {
          this.list.customer_level = val;
          this.$message.success("等级设置成功！");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    sortChange({column}) {
      this.query.sortby = {
        key: column.property,
        value: column.order == "descending" ? "desc" : "asc"
      };
      this.getMemberBindList(1)
    },

    open({ memberid }) {
      this.dialogVisible = true;
      this.memberid = memberid;
      this.query2.memberid = memberid;
      this.fetchData(memberid);
      store.commit("modify", false);
    },

    handleLeftMenuSelect(index) {
      if (index == this.currentActive) return;
      this.currentActive = index;
      if (index == "BindDevice") {
        this.query.pindex = 1;
        this.getMemberBindList(1);
      } else if (index == "ConsumeRecord") {
        this.query2.pindex = 1;
        this.fetchOrder(1);
      } else if (index == "ProductOrder") {
        this.productOrderQuery.pindex = 1;
        this.fetchProductOrder(1);
      }
    },

    showDialog() {
      this.dialogShow = true;
    },
    onOpen() {
      this.fetchTag();
    },
    onClosed() {
      this.list2 = [];
      this.checkedTagids = [];
    },

    submit() {
      setApi({
        type: "member",
        unique_key: this.memberid,
        tagids: this.checkedTagids,
      }).then((res) => {
        if (res.errno === 0) {
          this.fetchData(this.memberid);
          this.$message.success("操作成功！");
          this.dialogShow = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchData(memberid) {
      this.loading = true;
      getMemberProfileApi({ memberid: memberid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = Object.assign({}, res.data);
          this.tags = res.data.tags;
        }
      });
    },

    fetchTag() {
      getallApi({ type: "member" }).then((res) => {
        if (!res.errno) {
          this.list2 = res.data.list;
          fetchApi({ type: "member", unique_key: this.memberid }).then(
            (res2) => {
              if (!res2.errno) {
                this.checkedTagids = res2.data.list.map((v) => v.tagid);
              }
            }
          );
        }
      });
    },
    // 获取消费记录列表数据
    fetchOrder(page) {
      this.consumeLoading = true;
      if (page) this.query2.pindex = page;
      memberOrderApi(this.query2).then((res) => {
        this.consumeLoading = false;
        if (!res.errno) {
          this.order = res.data.list;
          this.total2 = res.data.total;
        }
      });
    },
    // 获取商品订单列表数据
    fetchProductOrder(page) {
      this.ProductOrderLoading = true;
      if (page) this.productOrderQuery.pindex = page;
      this.productOrderQuery.memberid = this.memberid;
      getGodProductOrderListApi(this.productOrderQuery).then((res) => {
        this.ProductOrderLoading = false;
        if (res.errno === 0) {
          this.productOrderList = res.data.list;
          this.productOrderListTotal = res.data.total;
        }
      });
    },
    // 获取绑定设备列表数据
    getMemberBindList(page) {
      this.tableLoading = true;
      if (page) this.query.pindex = page;
      this.query.memberid = this.memberid;
      getMemberBindListApi(this.query).then((res) => {
        this.tableLoading = false;
        if (res.errno === 0) {
          this.equips = res.data.list.map(i => {
            if (i.is_online && i.is_alarm && i.is_running) i.status = '告警运行'
            if (i.is_online && i.is_alarm && !i.is_running) i.status = '告警'
            if (i.is_online && !i.is_alarm && i.is_running) i.status = '正常运行'
            if (i.is_online && !i.is_alarm && !i.is_running) i.status = '在线'
            return i
          })
          this.total = res.data.total;
        } else {
          this.$message.error(res.messsage);
        }
      });
    },
    // 获取pro会员选项数据
    fetchProOptions() {
      proOptionsApi().then((res) => {
        if (!res.errno) {
          this.proList = res.data.list;
          this.select()
        }
      });
    },
    // 修改权限
    updateMemberAuth(command) {
      this.params = Object.assign(this.params, {
        equipid: command.equip.equipid,
        binderid: this.memberid,
        auth_level: command.rank,
      });
      updateEquipMemberAuthApi2(this.params).then((res) => {
        if (!res.errno) {
          this.equips[this.equips.indexOf(command.equip)].member_auth =
            command.rank;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 关闭用户详情弹框前的回调
    handleClose(done) {
      store.commit("modify", true);
      this.$destroy(true);
    },
    // 关闭用户详情弹框
    closeDialog() {
      this.dialogVisible = false;
    },
    // 编辑备注
    edit() {
      this.$prompt(`请输入备注信息`, this.list.nickname || "未授权用户", {
        inputValue: this.list.remark,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          postMemberProfileApi({ memberid: this.memberid, remark: value }).then(
            (res) => {
              if (!res.errno) {
                this.fetchData(this.memberid);
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {
          // 取消
        });
    },
    // 加入最小化收藏
    addCollected() {
      let query = {
        unique_key: this.memberid,
        type: "member",
      };
      addCollectionApi(query).then((res) => {
        if (!res.errno) {
          this.fetchData(this.memberid);
          this.$message.success("收藏成功！");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 取消最小化收藏
    cancelCollected() {
      let query = {
        unique_key: this.memberid,
        type: "member",
      };
      cancelCollectionApi(query).then((res) => {
        if (!res.errno) {
          this.fetchData(this.memberid);
          this.$message.success("取消收藏成功！");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 打开设备详情弹框
    toRmsDetail(id) {
      this.$detail({type:'equip',id:id});
    },
    // 赠送PRO会员
    gift() {
      this.fetchProOptions();
      this.proShow = true;
    },
    closePro() {
      this.proShow = false;
    },

    select(id) {
      if(id) {
        this.currentValue = id;
      }
      const temp = this.proList.filter(item => item.id == this.currentValue);
      this.total_payed = temp[0].selling_subtotal
      this.discount_fee = temp[0].market_subtotal - temp[0].selling_subtotal

      const today = parseInt(new Date().getTime() / 1000)
      if(this.list.expire_day) {
        // pro会员已过期
        if(this.list.expire_day < today) {
          this.expire_time = today + temp[0].num * 365 * 24 * 3600
        }else {
          // pro会员未过期
          this.expire_time = this.list.expire_day + temp[0].num * 365 * 24 * 3600
        }
      }else {
        // 未开通pro会员
        this.expire_time = today + temp[0].num * 365 * 24 * 3600
      }
    },

    immediatelyGift() {
      const temp = this.proList.filter(item => item.id == this.currentValue);

      const params = Object.assign({},{item:temp[0]},{memberid:this.memberid})
      proPresentApi(params).then(res => {
        if(!res.errno) {
          router.push(`/expense/order/cashier`)
          localStorage.setItem("__ORDERID__", res.data.orderid);
        }
      })
    },

    toggleAll() {
      this.$refs.equipBindList.toggleAllSelection();
    },

    handleSelectionChange(list) {
      this.multipleSelection = list;
    },

    openAuthDialog() {
      this.authorizedShow = true
    }
  },
};
</script>

<style lang="scss">
.el-dialog.member-detail-dialog {
  max-width: 1500px;
  max-height: 100vh;
  background-color: rgba(238, 240, 245, 1);
  padding-bottom: 20px;

  .el-dialog__header {
    padding-top: 0px;
    padding-bottom: 0px;
    background-color: #fff;
    margin-bottom: 20px;

    .el-dialog__close.el-icon.el-icon-close {
      font-size: 24px;
    }

    .menu-left {
      height: 100%;

      .el-menu.el-menu--horizontal {
        border: none;
      }

      .el-menu-item {
        min-width: 100px;
        font-size: 20px;
        text-align: center;
        user-select: none;
      }
    }
  }

  .el-dialog__body {
    padding: 0;
    height: 75vh;
  }
}

.el-tooltip__popper.minimize-collect {
  width: 104px;
  text-align: center;
}
.el-dialog__wrapper > .el-dialog.pro-dialog {
  height: 650px;
}

</style>

<style lang="scss" scoped>
.card-item {
  height: 100%;

  &:not(.basic-card) {
    /deep/ .el-card__body {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-bottom: 0;

      .card-top {
        height: 36px;
        flex-shrink: 0;
      }

      .card-table {
        flex: 1;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 0 !important;
          height: 0px !important;
        }
      }
    }
  }

  &.basic-card {
    /deep/ .el-card__body {
      height: 100%;
    }
  }
}

.star {
  &:hover {
    cursor: pointer;
  }
}

.box-border {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

/deep/.el-checkbox.is-bordered.el-checkbox--medium {
  padding-top: 9px;
}

/deep/ .el-menu {
  background-color: transparent;

  .el-menu-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .el-menu-item:focus {
    background-color: transparent;
  }
}

.content {
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid rgba(238, 240, 245, 1);
  max-width: 580px;
}

/deep/ .reverse {
  .all,
  .opts {
    border: 1px solid #dcdfe6 !important;
  }
}

.pro-dialog {
  // background-color: #F2BD72;
  .pro-item {
    width: 200px;
    height: 200px;
    position: relative;
    border-radius: 5px;
    text-align: center;
    border: 2px solid transparent;

    box-shadow: 0px 1px 20px 0px rgba(238, 240, 245, 100);

    &.active {
      width: 200px;
      border: 2px solid rgba(240, 173, 78, 1);
    }

    .check-bg {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 40px;
      height: 40px;
      background-color: rgba(240, 173, 78, 1);
      z-index: 2;
      border-top-left-radius: 40px;
    }

    .discount {
      position: absolute;
      bottom: -2px;
      right: -2px;
      width: 200px;
      height: 42px;
      display: flex;
      justify-content: center;
      background-color: #fbe6c9;
      font-size: 13px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      &.active {
        width: 196px;
        height: 40px;
        right: 0px;
        bottom: 0px;
      }

      .check {
        position: absolute;
        z-index: 3;
        bottom: -2px;
        right: -2px;
      }

      .save {
        height: 40px;
        line-height: 40px;
        color: rgba(240, 173, 78, 1);
      }
    }
  }

  .pro-item:nth-child(2) {
    margin: 0 30px;
  }
}

.border-right {
  border-right: 1px solid #dcdfe6;
}

.desc-title,
.desc-content {
  height: 40px;
  line-height: 40px;
}

.pro-pay {
  position: relative;
  .foot-gift {
    position: absolute;
    width: calc(100% - 60px);
    bottom: 0px;
    .button-gift {
      width: 100%;
    }
  }
}

.iconfont {
  font-size: 24px;
  line-height: 24px;
}
/deep/ .el-rate {
  height: 30px;
}
</style>
